export const ATA_SERVICES = [
  'Assurance',
  'Business Tax',
  'Business Valuation',
  'CFO Advisory',
  'Client Accounting Services',
  'Cybersecurity',
  'Forensic Accounting & Litigation Support',
  'Growth Advisory',
  'HR Advisory',
  'Individual Tax',
  'Managed IT Services',
  'Payroll Services',
  'Software Development / Automation / Integration',
  'Transaction Advisory',
] as const;

export const ATA_LOCATIONS = [
  'Boonville, IN',
  'Dale, IN',
  'Evansville, IN',
  'Princeton, IN',
  'Henderson, KY',
  'Murray, KY',
  'Owensboro, KY',
  'Tupelo, MS',
  'Covington, TN',
  'Dyersburg, TN',
  'Henderson, TN',
  'Jackson, TN',
  'Martin, TN',
  'Memphis, TN',
  'Milan, TN',
  'Nashville, TN',
  'Paris, TN',
  'Union City, TN',
] as const;

export const REFERRAL_STATUSES = [
  'Submitted',
  'UnderReview',
  'Qualified',
  'InProgress',
  'Won',
  'Lost',
  'Disqualified',
] as const;

export type ReferralStatus = (typeof REFERRAL_STATUSES)[number];

export const STATUS_LABELS: Record<ReferralStatus, string> = {
  Submitted: 'Submitted',
  UnderReview: 'Under Review',
  Qualified: 'Qualified',
  InProgress: 'In Progress',
  Won: 'Won',
  Lost: 'Lost',
  Disqualified: 'Disqualified',
};

import type { CommissionType, PayoutStatus } from '@/types/referral';

export const COMMISSION_TYPE_LABELS: Record<CommissionType, string> = {
  QualificationFee: 'Qualification Fee',
  RevenueShare: 'Revenue Share',
};

export const PAYOUT_STATUS_LABELS: Record<PayoutStatus, string> = {
  Pending: 'Pending',
  Approved: 'Approved',
  Paid: 'Paid',
};
